module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c002"
    }
  }, [_vm._v("Claiming the Crown (Hidden Falls High Series, #3)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("Dante Black")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nat")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dante")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note from Kailin Gow")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEWS")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("https://dl.bookfunnel.com/tjtn7bbb5y")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTHER RH or STEAMY ROMANCE from | Kailin Gow and Romance On the Go Books")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magical World")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0